module.exports = __webpack_public_path__ + "img/truck-plate-alt.fe435d92.svg";